<template>
  <base-row
    v-bind="$props"
    :selectable="isOrderEntry(item)"
  >
    <td v-if="!isOrderEntry(item)"></td>
    <td>
      {{ item.id }}
    </td>
    <td>
      <Link
        v-if="item.parent?.id"
        :href="parentLink(item.parent?.id)"
        class="font-semibold text-blue-600 hover:text-blue-600"
      >
        {{ item.parent?.lot_num }}<span v-if="item.parent?.batch_num"> (Batch: {{ item.parent?.batch_num }})</span>
        <br />
        <div class="text-xs">
          <Link
            :href="productLink(item.parent.product_id)"
            class="font-semibold text-blue-600 hover:text-blue-600"
          >
            {{ item.parent?.product_name || item.parent?.parent_id }}
          </Link>
          <span>
            <span> (</span>
            <span v-if="item.parent?.parent_id">{{ item.parent?.parent_id }}:</span>
            <span>{{ item.parent?.id }}</span>
            <span>)</span>
          </span>
        </div>
        <div
          v-if="item.parent?.sub_lot_num"
          class="text-xs"
        >
          <strong>Sub-lot: </strong>{{ item.parent.sub_lot_num }}
        </div>
      </Link>
      <span v-else> - </span>
    </td>
    <td>
      {{ item.parent?.location_name ?? 'Source' }}
    </td>
    <td>
      {{ item.display_type || '-' }}
    </td>
    <td>
      <Link
        v-if="item.causer_url"
        :href="item.causer_url"
        class="font-semibold text-blue-600 hover:text-blue-600"
      >
        {{ item.causer_display_value || '-' }}
      </Link>
      <span v-else>
        {{ item.causer_display_value || '-' }}
      </span>
    </td>
    <td>
      <Link
        v-if="getPersonLink(item)"
        :href="getPersonLink(item)"
        class="font-semibold text-blue-600 hover:text-blue-600"
      >
        {{ getPersonValue(item) || '-' }}
      </Link>
      <span v-else>
        {{ getPersonValue(item) || '-' }}
      </span>
    </td>
    <td>
      {{ item.amount || '-' }}
    </td>
    <td>
      Available: {{ getRemainingAvailable(item) || '-' }}
      <br />
      On-Hand: {{ getRemainingOnHand(item) || '-' }}
    </td>
    <td>
      {{ item.reason || '-' }}
    </td>
    <td>
      {{ _datetime(item.created_at) }}
    </td>
    <td>
      {{ _datetime(item.updated_at) }}
    </td>
    <td>
      {{ item.deleted_at ? _datetime(item.deleted_at) : '-' }}
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _datetime from '@/Filters/DateTime'
import { isOrderEntry } from '@/Pages/Products/BalanceEntries/Filters/BalanceEntries'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {},

  computed: {},

  methods: {
    _datetime,
    isOrderEntry,

    parentLink(id) {
      return route('packages.show', { package: id })
    },
    locationLink(id) {
      return route('company.locations.show', { location: id })
    },
    productLink(id) {
      return route('products.edit', { product: id })
    },
    getRemainingAvailable(item) {
      if (item.balances?.quantity_available) {
        return item.balances?.quantity_available
      }

      return null
    },
    getRemainingOnHand(item) {
      if (item.balances?.quantity_on_hand) {
        return item.balances?.quantity_on_hand
      }

      return null
    },
    getPersonLink(item) {
      if (item.user) {
        return null
        // return route('company.users.edit', { user: item.user.id });
      }

      if (item.customer) {
        return route('customers.show', { customer: item.customer.id })
      }

      return null
    },
    getPersonValue(item) {
      if (item.user && item.user.email) {
        return item.user.email
      } else if (item.user && item.user.id) {
        return `User #${item.user.id}`
      }

      if (item.customer) {
        return item.customer.email
      }

      return null
    }
  }
}
</script>
